import '@styles/webdesktop/stylesheets/instrumentTypeLogo.scss';
import { getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import React from 'react';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { Size } from '@front/sharedcomponents/Variables';
export const InstrumentTypeLogo = ({ instrumentType, clickable = false, onClick, size = Size.Medium, disabled = false }) => {
    const shortName = getInstrumentTypeShortName(instrumentType);
    const classNames = [
        'instrument-type-logo',
        size,
        clickable ? 'clickable' : '',
        disabled ? 'disabled' : '',
        isValidString(shortName) ? shortName.toLowerCase() : 'no-type'
    ];
    const className = classNames.filter(Boolean).join(' ');
    return clickable ? (React.createElement("button", { type: "button", className: "instrument-type-logo-button", onClick: onClick, disabled: disabled },
        React.createElement(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: className }, shortName))) : (React.createElement(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: className }, shortName));
};
